import { MouseEvent } from 'react';

import { Link } from 'react-router-dom';

type BreadcrumbLinkProps = {
  className?: string;
  onClick?: (e: MouseEvent<HTMLAnchorElement>) => void;
  [key: string]: unknown;
};

/**
 * Link component for breadcrumbs that handles optional `to` prop.
 * If `to` is undefined, renders a non-interactive span instead of a link.
 */
export function BreadcrumbLink({
  to,
  className,
  onClick,
  ...rest
}: BreadcrumbLinkProps & { to?: string }) {
  // If no destination, render as plain text (current page indicator)
  if (!to) {
    return <span className={className} {...rest} />;
  }

  return <Link to={to} className={className} onClick={onClick} {...rest} />;
}
